export default __webpack_public_path__ + "static/hugh-10b0b29cbf3a144f38c73c6ead19174e.jpeg";